import { ProductAnalytics } from './ProductAnalytics';

export { dataLayerSubscriber } from './dataLayerSubscriber';
export { ProductAnalytics } from './ProductAnalytics';

export default new ProductAnalytics();
